import { connect } from 'react-redux';
import IdentificationForm from './IdentificationForm';
import { identifyUser } from '../../actions/session';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  loginFailed: state.session.loginFailed,
  loginFailedMessage: state.session.loginFailedMessage,
  requiresEmployer: state.session.requiresEmployer,
  createUserIfNotExists: state.session.createUserIfNotExists,
  relaxedSotuVerificationEnabled: state.organization.relaxedSotuVerificationEnabled
});

const mapDispatchToProps = dispatch => ({
  identifyUser: dispatch(identifyUser)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentificationForm);



// WEBPACK FOOTER //
// ./src/containers/IdentificationForm/index.js